import { LocalStorageService } from "@dodo/local-storage";
import { Base64Service } from "./base64.service";
import { ServiceLocator } from "app/locator.service";

export abstract class ComponentService<T> {
	protected _state: T;
	protected abstract _localStorageKey: string;
	private __localStorageService: LocalStorageService;
	private __base64Service: Base64Service;

	constructor(private __storeEncrypted = false) {
		this.__localStorageService = ServiceLocator.injector.get(
			LocalStorageService
		);
		this.__base64Service = ServiceLocator.injector.get(Base64Service);
		this._state = <T>{};
	}

	protected _storeState() {
		if (this.__storeEncrypted) {
			this._storeStateWithEncrypted();
		} else {
			this._storeStateWithoutEncryption();
		}
	}

	protected _storeStateWithEncrypted() {
		this.__localStorageService.setInSessionStorage(
			this._localStorageKey,
			this.__base64Service.encodeJson(this._state)
		);
	}

	protected _storeStateWithoutEncryption() {
		this.__localStorageService.setInSessionStorage(
			this._localStorageKey,
			this._state
		);
	}

	protected _restoreState() {
		if (this.__storeEncrypted) {
			return this._restoreEncryptedState();
		} else {
			return this._restoreNonEncryptedState();
		}
	}

	protected _restoreEncryptedState(): boolean {
		const encState = this.__localStorageService.getFromSessionStorage(
			this._localStorageKey
		);
		if (encState) {
			const obj = <T>this.__base64Service.decodeJson(encState);
			if (obj) {
				this._state = obj;
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	}

	protected _restoreNonEncryptedState(): boolean {
		const state = this.__localStorageService.getFromSessionStorage(
			this._localStorageKey
		);

		if (state) {
			this._state = state;
			return true;
		} else {
			return false;
		}
	}
}
